<template>
  <v-row justify="center" class="pt-3">
    <v-col class="col-10">
      <v-row>
        <div v-if="label" class='col-10 frise-label ps-0 pb-0 pt-1'>
            {{ label }}
        </div>
        <v-col @click="editPlanning" class="col-12 pe-0">
          <v-row v-if="!hideHours" style="position:relative; width:100%;">
            <div v-for="n in 4" :key="n" style="width: 25%;">
                <v-row class="m-0 align-end pb-1" v-if="n == 1">
                      <div class="time-label">00:00</div>
                </v-row>
                <v-row class="m-0 align-end" v-if="n == 2">
                      <div class="time-label">06:00</div>
                </v-row>
                <v-row class="m-0 align-end" v-if="n == 3">
                      <div class="time-label">12:00</div>
                </v-row>
                <v-row class="m-0 align-end" v-if="n == 4">
                    <div class="time-label">18:00</div>
                    <v-spacer style="height:0"></v-spacer>
                    <div style="font-size: 10px; height: 22px"></div>
                </v-row>
            </div>
          </v-row>
          <v-row class="background-frise">
            <div style="height: 10px; width: 25%"></div>
            <div v-for='(plage, index) in sortedPlages' :key='index'
                class="frise-color" :style="getMargin(plage, index) + ' ' + getBackgroundColor(plage)">
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>


<script lang="ts">
import { DateFormat } from "@/framework/base/helpers/DateFormat";
import Plage from "@/framework/base/classes/Plage";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: 'FriseComponent',
  props: {
    plages: {
      type: Object as PropType<any>
    },
    readOnly: {
      type: Boolean
    },
    label: {
      type: String
    },
    hideHours: {
      type: Boolean
    }
  },
  computed: {
    sortedPlages(): Plage[] {
      return this.sortPlages();
    }
  },
  methods: {
    editPlanning() {
      if (!this.readOnly) {
        this.$emit('editPlanning');
      }
    },
    sortPlages() {
      const sortedPlage = [...this.plages];
      sortedPlage.sort((a: Plage, b: Plage) => {
        if (a.heureDebut && b.heureDebut) {
          const current = DateFormat.getHeures(a.heureDebut.toString())
          const next = DateFormat.getHeures(b.heureDebut.toString())
          if (current && next) {
            return current - next
          }
        }
        return -1;
      })
      return sortedPlage;
    },
    getBackgroundColor(plage: any): string {
      let res = 'background-color: ';
      if (plage.color && plage.valid) {
        res += plage.color + ';';
      } else if (!plage.valid) {
        res += "#e42125;"
      } else {
        res += "#2A97DA;"
      }
      return res;
    },
    getMargin(plage: Plage, index: number) {
      let start: number | null = 0;
      let end: number | null = 0;
      let marginRight = '';
      let marginLeft = '';
      let width = '';
      if (plage.heureDebut && plage.heureFin) {
        start = DateFormat.getHeures(plage.heureDebut.toString());
        end = DateFormat.getHeures(plage.heureFin.toString());
      }
      if (start && end) {
        let widthLength = (100 / (24 / (end - start)));
        if (widthLength < 0) {
          widthLength = 100 + widthLength;
        }
        width = 'width: ' + widthLength + '%;'
        if (index == 0) {
          marginLeft = 'margin-left:' + (100 / (24 / start)) + '%;'
        }
        marginRight = 'margin-right:' + (100 - (100 / (24 / end))) + '%;'
        if (index != 0) {
          const previousPlage = this.plages[index - 1]
          if (previousPlage && previousPlage.heureFin) {
            const previousEnd = DateFormat.getHeures(previousPlage.heureFin.toString());
            marginLeft = previousEnd ? 'margin-left:' + 100 / (24 / (start)) + '%;' : ''
          }
        }
      }
      return marginLeft + ' ' + marginRight + ' ' + width;
    }
  }
})


</script>


<style>
.time-label {
  font-size: 12px;
  font-weight: 800;
  color: #363737;
}

.frise-label {
    font-size: 13px;
    color: var(--v-primary-base) !important;
}

.background-frise {
  background-color: #D9D9D9;
  border-radius: 10px;
  position: relative;
  width: 100%;
}

.frise-color {
  border-radius: 10px;
  position:absolute;
  height: 10px;
}
</style>
